"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRegisterCurrencyInstruction = void 0;
const anchor_1 = require("@project-serum/anchor");
const utils_1 = require("../utils");
/**
 * Returns an instruction which registers a valid currency with the market. Update authority must match marketVarsAccount.
 *
 * @param connection
 * @param updateAuthorityAccount - Public key of registered update authority
 * @param royalty - Associated royalty fee with 1,000,000 equaling 100%
 * @param saCurrencyVault - Star Atlas token account which will receive royalties
 * @param currencyMint - Mint address of currency being registered
 * @param programId - Deployed program ID for GM program
 */
function createRegisterCurrencyInstruction({ connection, updateAuthorityAccount, royalty, saCurrencyVault, currencyMint, programId, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const program = (0, utils_1.getMarketplaceProgram)({ connection, programId });
        const instructions = [
            yield program.methods
                .registerCurrency(new anchor_1.BN(royalty))
                .accounts({
                updateAuthorityAccount,
                saCurrencyVault,
                currencyMint,
            })
                .instruction(),
        ];
        return {
            accounts: [],
            instructions,
        };
    });
}
exports.createRegisterCurrencyInstruction = createRegisterCurrencyInstruction;
//# sourceMappingURL=registerCurrency.js.map